<template>
  <div class="section pt-0">
    <div class="section">
      <div class="columns">
        <div class="column">
          <h1 class="title is-1">Manage Tag</h1>
        </div>
      </div>
    </div>
    <div class="section pt-0">
      <div class="columns">
        <!-- Left Box - Tag Detail -->
        <div class="column">
          <div class="is-flex is-justify-content-space-between">
            <h4 class="title is-4">Tag</h4>
            <b-button
              icon-left="trash"
              type="is-light"
              @click="confirmTagDelete"
            />
          </div>
          <div class="block">
            <TagEdit :tag="theTag(tagId)" @submitted="updateTag" />
          </div>
        </div>
        <!-- End of Left Box -->

        <!-- Right Box - Routes -->
        <div class="column">
          <h4 class="title is-4">Routes</h4>
          <div class="box">
            <!-- Product Select -->
            <b-field label="Produkt" class="mb-5" id="product-select">
              <b-select
                expanded
                placeholder="Produkt auswählen..."
                v-model="selectedProductId"
                @input="changeProduct"
                icon="circle"
                :class="selectedProductStatus"
              >
                <option
                  v-for="option in products"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <!-- End of Product Select -->

            <!-- Route Tree -->
            <RouteTree :productId="Number(selectedProductId)" height="295px">
              <template #item-action="{ route }">
                <b-checkbox
                  v-model="route.tags"
                  :native-value="theTag(tagId)"
                  @change.native="updateRoute(route)"
                />
              </template>
            </RouteTree>
            <!-- End of Route Tree -->
          </div>
        </div>
        <!-- End of Right Box -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TagEdit from "@/components/editProduct/TagEdit.vue";
import RouteTree from "@/components/editProduct/RouteTree.vue";

/**
 * Tag Edit:
 * [x] Tags info (name / commonly searched) on the left
 * [x] Product switcher and route tree on the right
 * [x] Checkbox on every route tree item
 * [x] Add/remove tag to/from the route on checkbox click
 */

export default {
  name: "ViewTag",
  components: {
    TagEdit,
    RouteTree
  },
  props: ["tagId"],
  data() {
    return {
      selectedProductId: null
    };
  },
  computed: {
    ...mapGetters({
      theTag: "tag/dataById",
      products: "product/data",
      productById: "product/dataById"
    }),
    selectedProductStatus() {
      return this.productById(this.selectedProductId)?.enabled
        ? "enabled"
        : "disabled";
    }
  },
  methods: {
    updateTag(payload) {
      this.$store.dispatch("tag/UPDATE", payload);
    },
    changeProduct(selectedProductId) {
      this.selectedProductId = selectedProductId;
    },
    updateRoute(route) {
      const { id, tags } = route;

      const payload = {
        id,
        product_id: Number(this.selectedProductId),
        tags: tags.map(tag => tag.id) // [tagObj] => [tagId]
      };

      this.$store.dispatch("product/route/UPDATE", payload);
    },
    confirmTagDelete() {
      this.$buefy.dialog.confirm({
        title: "Tag löschen",
        // eslint-disable-next-line max-len
        message:
          "Sind Sie sicher, dass Sie alle ausgewählen Tag löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden!",
        confirmText: "Tag löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.deleteTag({ id: Number(this.tagId) })
      });
    },
    deleteTag({ id }) {
      this.$store.dispatch("tag/DELETE", { id });
    }
  }
};
</script>

<style>
#product-select .control.has-icons-left.disabled .icon {
  color: #f14668 !important;
}

#product-select .control.has-icons-left.enabled .icon {
  color: #48c774 !important;
}
</style>
